import { __decorate } from "tslib";
import Vue from "vue";
import Component from 'vue-class-component';
let NavUser = class NavUser extends Vue {
};
NavUser = __decorate([
    Component
], NavUser);
export default NavUser;
